<div class="row py-5 border-bottom">

  <div class="col-md-12 col-xl-4" [class.offset-xl-2]="fundLogic.modFund.type === 5">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 0" [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 0" (click)="switchTo(0)">
      Subir<br>Reglamento
    </button>
  </div>

  <div *ngIf="fundLogic.modFund.type !== 5" class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 1" [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 1" (click)="switchTo(1)">
      Fechas De<br>Ciclo
    </button>
  </div>

  <div class="col-md-6 mt-2 col-xl-4 mt-xl-0">
    <button [ngClass]="'btn btn-block'" [class.btn-primary]="contentLocation.savingParametersIndex === 2" [class.btn-outline-secondary]="contentLocation.savingParametersIndex !== 2" (click)="switchTo(2)">
      Compañías<br>Incluidas
    </button>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 0">

  <div class="row ml-1 mr-1 my-5 border">
    <div class="col-md-12">
      <div class="file-upload">
        <label>
          <div class="icon my-5">
            <i class="material-icons">file_upload</i>
          </div>
          <input type="file" (change)="detectFiles($event)" multiple>
        </label>

        <h6 class="my-5 text-center">
          Reglamento:
          <a *ngIf="downloadURL; else noURL" href="{{downloadURL}}" target="_blank">
            {{downloadURL}}
          </a>
          <ng-template #noURL>

            <span *ngIf="fundLogic.modFund.fileUploaded.name; else noFileSelected">
              {{fundLogic.modFund.fileUploaded.name}}
            </span>

            <ng-template #noFileSelected>
              <span>
                No se ha seleccionado ningún archivo
              </span>
            </ng-template>

          </ng-template>

        </h6>

      </div>
    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 1">

  <div class="mt-5 row">

    <div class="col-md-4">
      <mat-form-field>
        <input matInput [matDatepicker]="inicioDeCicloPicker" placeholder="Inicio:" (dateChange)="setRegistrationDate('starts', $event)" [value]="newRegistrationDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="inicioDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #inicioDeCicloPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="col-md-4">
      <mat-form-field>
        <input matInput [matDatepicker]="finDeCicloPicker" placeholder="Fin:" (dateChange)="setRegistrationDate('ends', $event)" [value]="newRegistrationDate.endDate" [min]="newRegistrationDate.startDate" [disabled]="!newRegistrationDate.startDate">
        <mat-datepicker-toggle matSuffix [for]="finDeCicloPicker"></mat-datepicker-toggle>
        <mat-datepicker #finDeCicloPicker [disabled]="!newRegistrationDate.startDate"></mat-datepicker>
      </mat-form-field>
    </div>

  </div>


  <div class="row">
    <div class="col-md-4 offset-md-8 center-vertically">
      <button class="btn-block" mat-raised-button color="primary" (click)="addRegistrationDate()">Añadir Fechas</button>
    </div>
  </div>

  <div class="my-5 row border-top" *ngIf="fundLogic.modFund.fundDates.length > 0">
    <div class="col-md-12">

      <mat-table #datesTable class="table" [dataSource]="fundLogic.modFund.fundDates">

        <ng-container matColumnDef="Inicio">
          <mat-header-cell *matHeaderCellDef> Inicio </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.startDate | date: 'mediumDate'}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="Fin">
          <mat-header-cell *matHeaderCellDef> Fin </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{element.endDate ? (element.endDate | date: 'mediumDate') :
                ''}}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="active">
          <mat-header-cell *matHeaderCellDef> Fecha Activa </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-checkbox [(ngModel)]="element.active" [disabled]="false">Fecha Activa</mat-checkbox>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="delete" class="center-text">
          <mat-header-cell *matHeaderCellDef><span>Eliminar</span></mat-header-cell>
          <mat-cell *matCellDef="let index = index">
            <button mat-icon-button color="warn" (click)="deleteRegistrationDate(index)">
              <mat-icon aria-label="Delete">delete_outline</mat-icon>
            </button>

          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedFundDatesColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedFundDatesColumns;"></mat-row>

      </mat-table>

    </div>
  </div>

</div>

<div *ngIf="contentLocation.savingParametersIndex == 2">

  <div class="row" *ngIf="logicService.dataManager.generalDataLoader.companies">

    <div class="col-md-12">

      <mat-table #companiesTable class="table" [dataSource]="logicService.dataManager.generalDataLoader.companies">


        <ng-container matColumnDef="companyID">
          <mat-header-cell mat-header-cell *matHeaderCellDef> ID </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyID}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="companyName">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Nombre de la Compañía </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.companyName}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="taxationIdentificationNumber">
          <mat-header-cell mat-header-cell *matHeaderCellDef> Documento Legal </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let element"> {{element.taxationIdentificationNumber}} </mat-cell>
        </ng-container>

        <ng-container matColumnDef="select">
          <mat-header-cell mat-header-cell *matHeaderCellDef>
            Incluir Compañía
          </mat-header-cell>
          <mat-cell mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selectionCompanies.toggle(row) : null"
              [checked]="selectionCompanies.isSelected(row)"></mat-checkbox>
          </mat-cell>
        </ng-container>

        <mat-header-row mat-header-row *matHeaderRowDef="displayedCompanyColumns"></mat-header-row>
        <mat-row mat-row *matRowDef="let row; columns: displayedCompanyColumns;"></mat-row>
      </mat-table>

    </div>

  </div>

</div>
